import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertCard(component) {
  var properties = component.properties;
  var _ref = properties,
    title = _ref.title,
    textContent = _ref.textContent;
  return {
    brick: "eo-card",
    properties: _objectSpread({
      themeVariant: "elevo",
      cardTitle: title,
      background: "#fff",
      outline: "background"
    }, textContent ? {
      textContent: textContent
    } : null)
  };
}
//# sourceMappingURL=convertCard.js.map